import React, { useState } from "react";
import { createPortal } from "react-dom";
import { XMarkIcon } from "@heroicons/react/24/solid";
import { rtdb } from "../../../config/firebase";
import { ref, push, update } from "firebase/database";

export default function TestimonialModal({ testimonial, onClose, isNew }) {
  const [formData, setFormData] = useState({
    nama: testimonial?.nama || "",
    perusahaan: testimonial?.perusahaan || "",
    keterangan: testimonial?.keterangan || "",
    rating: testimonial?.rating || 5,
  });

  const handleChange = (e) =>
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleRating = (value) =>
    setFormData((prev) => ({ ...prev, rating: value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const testimonialsRef = ref(rtdb, "testimonials");
      if (isNew) {
        await push(testimonialsRef, formData);
      } else {
        const testimonialRef = ref(rtdb, `testimonials/${testimonial.id}`);
        await update(testimonialRef, formData);
      }
      onClose();
    } catch (error) {
      console.error("Gagal menyimpan testimonial:", error);
      alert("Terjadi kesalahan saat menyimpan data!");
    }
  };

  return createPortal(
    <div
      className="fixed inset-0 z-[9999] flex justify-center items-center bg-black/40 backdrop-blur-sm p-4"
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-xl shadow-2xl w-full max-w-xl overflow-hidden"
      >
        {/* Header */}
        <div className="flex justify-between items-center p-5 border-b">
          <h3 className="text-xl font-bold text-gray-800">
            {isNew ? "Tambah Testimonial" : "Edit Testimonial"}
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition"
          >
            <XMarkIcon className="w-6 h-6" />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Nama
              </label>
              <input
                type="text"
                name="nama"
                value={formData.nama}
                onChange={handleChange}
                required
                className="mt-1 block w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-green-500 focus:border-green-500"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">
                Perusahaan/Asal
              </label>
              <input
                type="text"
                name="perusahaan"
                value={formData.perusahaan}
                onChange={handleChange}
                required
                className="mt-1 block w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-green-500 focus:border-green-500"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Keterangan
            </label>
            <textarea
              name="keterangan"
              value={formData.keterangan}
              onChange={handleChange}
              required
              rows={4}
              className="mt-1 block w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-green-500 focus:border-green-500"
            />
          </div>

          {/* Rating Interaktif */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Rating
            </label>
            <div className="flex">
              {[1, 2, 3, 4, 5].map((i) => (
                <span
                  key={i}
                  className={`w-6 h-6 cursor-pointer mr-1 text-2xl ${
                    i <= formData.rating
                      ? "text-yellow-400"
                      : "text-gray-300"
                  } transition-all hover:text-yellow-300`}
                  onClick={() => handleRating(i)}
                >
                  &#9733;
                </span>
              ))}
            </div>
          </div>

          {/* Tombol */}
          <div className="pt-4 flex justify-end border-t">
            <button
              type="button"
              onClick={onClose}
              className="mr-3 px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200"
            >
              Batal
            </button>
            <button
              type="submit"
              className="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-lg hover:bg-green-700 shadow-md"
            >
              {isNew ? "Tambah" : "Simpan"}
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
}
